import { apiClient } from "../config";

async function archiveOrRestoreCategory(id: any, status: any) {
  const url = `/admin/categories/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreCategory;
